import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { formatEmployeeThaiName } from '../../utils/functions/employeeName';

const FinanceExcel = ({ data, fileName }) => {
  const getExpenseTypeLabel = (type) => {
    const normalizedType = String(type || '').toUpperCase();

    if (normalizedType === 'REFUND') return 'เบิกคืน';
    if (normalizedType === 'PAY') return 'เบิกเพื่อจ่าย';

    return type || '';
  };

  const exportToExcel = () => {
    // Create worksheet
    const worksheet = XLSX.utils.aoa_to_sheet([
      ['EXPENSE REPORT'], // Report title
    ]);

    // Transform data for Excel format
    const excelData = data.map((item) => {
      const netAmount =
        item?.net_price != null
          ? item.net_price
          : (item?.price || 0) - (item?.withholding_tax || 0) || 0;
      const withholdingTax = Number(item?.withholding_tax) || 0;
      const vatRate = item?.includes_vat ? 7 : '-';
      const vatAmount = item?.includes_vat ? item?.vat_amount || 0 : '-';
      const withholdingTaxRate =
        withholdingTax > 0 ? item?.withholding_tax_rate || 0 : '-';
      const withholdingTaxAmount = withholdingTax > 0 ? withholdingTax : '-';

      return {
        Date: item?.date ? new Date(item.date).toLocaleDateString() : '',
        id: item?.code,
        Project_Id: item?.project?.project_number || '',
        Project_Name: item?.project?.name || '',
        BudgetNumber: `${item?.budget?.prefix || ''}${
          item?.budget?.budget_number || ''
        }`,
        Budget: item?.budget?.name || '',
        Expense_Type: getExpenseTypeLabel(item?.expenses_type),
        Oeder: item?.name || '',
        ยอดจ่ายจริง: netAmount,
        'Withholding_Tax_%': withholdingTaxRate,
        Withholding_Tax_Amount: withholdingTaxAmount,
        'VAT_%': vatRate,
        VAT_Amount: vatAmount,
        Payee: item?.payee?.name || '',
        Bank: item?.payee?.bank || '',
        Account: item?.payee?.account_number || '',
        Status: item?.status || '',
        Applicant: formatEmployeeThaiName(item?.employee),
      };
    });

    // Append data to worksheet starting from row 4
    XLSX.utils.sheet_add_json(worksheet, excelData, {
      origin: 'A2', // Start from row 2
      skipHeader: false,
    });

    // Set column widths
    const columnWidths = [
      { wch: 12 }, // Date
      { wch: 15 }, // ID
      { wch: 20 }, // Project ID
      { wch: 30 }, // Project
      { wch: 20 }, // Budget number
      { wch: 30 }, // Budget
      { wch: 18 }, // Expense type
      { wch: 40 }, // Oeder
      { wch: 15 }, // Amount
      { wch: 20 }, // Withholding tax rate
      { wch: 22 }, // Withholding tax amount
      { wch: 10 }, // VAT rate
      { wch: 15 }, // VAT amount
      { wch: 20 }, // Payee
      { wch: 15 }, // Bank
      { wch: 18 }, // Account
      { wch: 12 }, // Status
      { wch: 20 }, // Employee
    ];
    worksheet['!cols'] = columnWidths;

    // Set cell merges for header
    worksheet['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 17 } }, // Merge cells for company name
    ];

    // Add some styling to header cells
    worksheet.A1 = {
      v: 'EXPENSE REPORT',
      s: {
        font: { bold: true, sz: 16 },
        alignment: { horizontal: 'center' },
      },
    };

    // Create workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Expenses');

    // Generate buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    // Create blob and save file
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `${fileName}_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  return { exportToExcel };
};

export default FinanceExcel;
